import { render } from "./TextCard.vue?vue&type=template&id=2197ae64&scoped=true"
import script from "./TextCard.vue?vue&type=script&lang=js"
export * from "./TextCard.vue?vue&type=script&lang=js"

import "./TextCard.vue?vue&type=style&index=0&id=2197ae64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2197ae64"]])

export default __exports__